import expect from "../util/expect"

export const POKAL_JWT_TOKEN: string = "POKAL_TOKEN_V2"

export default async function expectJwt(): Promise<string> {
    return expect(getJwt())
}

export function expectJwtSync(): string {
    return expect(getJwt())
}

export function getJwt(): string | null {
    return localStorage.getItem(POKAL_JWT_TOKEN)
}

export function setJwt(token: string) {
    localStorage.setItem(POKAL_JWT_TOKEN, token)
}

export function removeJwt() {
    localStorage.removeItem(POKAL_JWT_TOKEN)
}
